import React from "react";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { CustomNoRowsOverlay } from "./CustomNoRowsOverlay";
import styles from "./styles";
import useCss from "../../hooks/useCss";

interface Props {
  rows: GridRowsProp;
  columns: GridColDef[];
  handleEditRowsModelChange?: (model: Record<string, unknown>) => void;
  handleIsCellEditable?: (params: { row: unknown; field: string }) => boolean;
  isLoading?: boolean;
}

const SbuxDataGrid = ({
  rows,
  columns,
  handleEditRowsModelChange,
  handleIsCellEditable,
  isLoading = false,
}: Props) => {
  const classes = useCss(styles);
  return (
    <div className={classes.root}>
      <DataGrid
        className={classes.dataGridRoot}
        rows={rows}
        columns={columns}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        hideFooter
        hideFooterSelectedRowCount
        isCellEditable={handleIsCellEditable}
        disableRowSelectionOnClick
        hideFooterPagination
        rowHeight={32}
        getRowClassName={(config) => {
          return config.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
        }}
        disableColumnMenu
        loading={isLoading}
      />
    </div>
  );
};

export default React.memo(SbuxDataGrid);
